import { render, staticRenderFns } from "./baseCommission6.vue?vue&type=template&id=782338f5&scoped=true"
import script from "./baseCommission6.vue?vue&type=script&lang=js"
export * from "./baseCommission6.vue?vue&type=script&lang=js"
import style0 from "./baseCommission6.vue?vue&type=style&index=0&id=782338f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782338f5",
  null
  
)

export default component.exports